/**
 * Brotege — Moisturizer Subscription Free Gift (Tube Key)
 * ------------------------------------------------------
 * Adds the Tube Key (qty 1, max) to the cart at $0 when the Moisturizer is
 * in the cart as a subscription. Removes it when no moisturizer-sub line is
 * present. Locks the Tube Key line so the customer cannot edit/remove it.
 * Disables checkout while the cart is being reconciled.
 *
 * Renewals: this script only runs on the storefront, so Recharge renewals
 * (which happen server-side) will never carry the gift — first order only,
 * by design.
 *
 * Performance: single narrow MutationObserver, hard 800ms rate limit, cart
 * signature cache to skip no-op syncs. No setInterval loops. No fetch wrap.
 *
 * Author: Anabia Technologies
 */
(function () {
  'use strict';

  if (window.broTubeKeyGiftLoaded) return;
  window.broTubeKeyGiftLoaded = true;

  // ---------- Config ----------
  var MOISTURIZER_VARIANT_ID = 51553619149085;
  var TUBE_KEY_VARIANT_ID    = 51258792378653;
  var GIFT_PROPERTY_KEY      = '_brotege_gift';
  var GIFT_PROPERTY_VALUE    = 'subscription-bonus';
  var GIFT_BADGE_TEXT        = 'FREE GIFT';

  var DEBOUNCE_MS            = 400;
  var MIN_SYNC_GAP_MS        = 800;   // hard rate limit
  var OBSERVER_DEBOUNCE_MS   = 250;

  var CHECKOUT_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href$="/checkout"]',
    '[data-checkout-button]',
    '.cart__checkout',
    '.cart-checkout',
    '#checkout',
    '.shopify-payment-button__button'
  ].join(',');

  // ---------- State ----------
  var syncing = false;
  var debounceTimer = null;
  var observerDebounceTimer = null;
  var lastSyncAt = 0;
  var lastCartSignature = '';
  var observerAttached = false;

  // ---------- CSS injection ----------
  function injectStyles() {
    if (document.getElementById('bro-tube-key-gift-styles')) return;
    var css = ''
      + '.bro-gift-line .input,\n'
      + '.bro-gift-line [x-ref="quantityControl"] > div:first-child { display: none !important; }\n'
      + '.bro-gift-line a[\\@click\\.prevent="remove"],\n'
      + '.bro-gift-line [x-ref="quantityControl"] > div:last-child { display: none !important; }\n'
      + '.bro-gift-badge {\n'
      + '  display: inline-block; font-family: var(--heading-font-stack, inherit);\n'
      + '  font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px;\n'
      + '  font-size: 10px; background: #1c1c1c; color: #fff;\n'
      + '  padding: 3px 8px; margin-top: 6px; border: 1px solid #2a2a2a;\n'
      + '}\n'
      + '.bro-gift-line .bro-gift-fixed-qty {\n'
      + '  display: inline-block; font-size: 12px; color: #777; margin-top: 6px;\n'
      + '}\n'
      + '.bro-gift-line a {\n'
      + '  pointer-events: none !important; cursor: default !important;\n'
      + '}\n'
      + '.bro-gift-line a img { pointer-events: none !important; }\n'
      + '.bro-checkout-locked {\n'
      + '  opacity: 0.5 !important; pointer-events: none !important; cursor: progress !important;\n'
      + '}\n';
    var style = document.createElement('style');
    style.id = 'bro-tube-key-gift-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  // ---------- Cart API ----------
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCart() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function addTubeKey() {
    var props = {};
    props[GIFT_PROPERTY_KEY] = GIFT_PROPERTY_VALUE;
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: TUBE_KEY_VARIANT_ID, quantity: 1, properties: props }] })
    }).then(function (r) { return r.json(); });
  }

  function changeLineByKey(lineKey, qty) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // ---------- Cart analysis ----------
  function hasMoisturizerSub(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === MOISTURIZER_VARIANT_ID && it.selling_plan_allocation) return true;
    }
    return false;
  }

  function tubeKeyLines(cart) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === TUBE_KEY_VARIANT_ID) out.push(cart.items[i]);
    }
    return out;
  }

  /** Cheap fingerprint of cart state relevant to our logic. */
  function cartSignature(cart) {
    var moiSub = 0, tk = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === MOISTURIZER_VARIANT_ID && it.selling_plan_allocation) {
        moiSub += it.quantity;
      } else if (it.variant_id === TUBE_KEY_VARIANT_ID) {
        tk += it.quantity;
      }
    }
    return 'm:' + moiSub + '|k:' + tk + '|c:' + cart.item_count;
  }

  // ---------- Checkout lock ----------
  function setCheckoutLocked(locked) {
    var btns = document.querySelectorAll(CHECKOUT_SELECTORS);
    btns.forEach(function (b) {
      if (locked) {
        b.classList.add('bro-checkout-locked');
        b.setAttribute('aria-busy', 'true');
        if ('disabled' in b) b.disabled = true;
        // For <a> tags
        if (b.tagName === 'A') {
          b.dataset.broHref = b.getAttribute('href') || '';
          b.removeAttribute('href');
        }
      } else {
        b.classList.remove('bro-checkout-locked');
        b.removeAttribute('aria-busy');
        if ('disabled' in b) b.disabled = false;
        if (b.tagName === 'A' && b.dataset.broHref !== undefined) {
          b.setAttribute('href', b.dataset.broHref);
          delete b.dataset.broHref;
        }
      }
    });
  }

  // ---------- Sync ----------
  function syncGift(force) {
    if (syncing) return Promise.resolve();
    var now = Date.now();
    if (!force && now - lastSyncAt < MIN_SYNC_GAP_MS) return Promise.resolve();

    syncing = true;

    return getCart()
      .then(function (cart) {
        var sig = cartSignature(cart);
        // Cheap skip: if the cart hasn't changed in any way that matters,
        // and our UI lock is already applied, do nothing.
        if (sig === lastCartSignature) {
          lockGiftLine();
          return 'noop';
        }
        lastCartSignature = sig;

        var moiSub = hasMoisturizerSub(cart);
        var lines = tubeKeyLines(cart);
        var currentQty = lines.reduce(function (n, l) { return n + l.quantity; }, 0);

        if (!moiSub && currentQty === 0) return 'noop';
        if (moiSub && currentQty === 1 && lines.length === 1) return 'noop';

        // Need to mutate — lock checkout
        setCheckoutLocked(true);

        if (!moiSub && currentQty > 0) {
          // Remove all tube-key lines
          var rmChain = Promise.resolve();
          lines.forEach(function (ln) {
            rmChain = rmChain.then(function () { return changeLineByKey(ln.key, 0); });
          });
          return rmChain.then(function () { return 'removed'; });
        }

        if (moiSub && currentQty === 0) {
          return addTubeKey().then(function () { return 'added'; });
        }

        // moiSub && (currentQty !== 1 || lines.length > 1) → normalize to single line, qty 1
        var normChain = Promise.resolve();
        for (var i = 1; i < lines.length; i++) {
          (function (k) { normChain = normChain.then(function () { return changeLineByKey(k, 0); }); })(lines[i].key);
        }
        if (lines[0].quantity !== 1) {
          normChain = normChain.then(function () { return changeLineByKey(lines[0].key, 1); });
        }
        return normChain.then(function () { return 'normalized'; });
      })
      .then(function (action) {
        if (action && action !== 'noop') {
          // Invalidate signature since we mutated
          lastCartSignature = '';
          return refreshDrawerHTML().then(function () {
            // Tell other Brotege scripts (pricing, etc.) to recompute
            if (typeof window.updateBroPrices === 'function') window.updateBroPrices();
          });
        }
      })
      .catch(function (err) {
        console.warn('[Tube Key Gift] sync failed:', err);
        lastCartSignature = ''; // force re-check next time
      })
      .then(function () {
        lastSyncAt = Date.now();
        syncing = false;
        setCheckoutLocked(false);
        lockGiftLine();
      });
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { syncGift(false); }, DEBOUNCE_MS);
  }

  // ---------- Drawer refresh (only after our own mutations) ----------
  function refreshDrawerHTML() {
    return fetch(window.location.pathname, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var tpl = doc.querySelector('template[data-should-teleport="#right-drawer-slot"]');
        if (tpl) {
          var newC = tpl.content.querySelector('.flex.flex-auto.flex-col');
          var liveC = document.querySelector('#right-drawer-slot .flex.flex-auto.flex-col');
          if (newC && liveC) liveC.innerHTML = newC.innerHTML;
        }

        if (window.location.pathname.indexOf('/cart') === 0) {
          var nForm = doc.querySelector('form.cart__contents');
          var lForm = document.querySelector('form.cart__contents');
          if (nForm && lForm && lForm.parentNode) lForm.parentNode.replaceChild(nForm, lForm);
        }
      })
      .catch(function () { /* swallow */ });
  }

  // ---------- UI lock on the gift line ----------
  function lockGiftLine() {
    var inputs = document.querySelectorAll('input[data-variant-id="' + TUBE_KEY_VARIANT_ID + '"]');
    if (inputs.length === 0) return;

    inputs.forEach(function (input) {
      var li = input.closest('li[data-line-item-key]');
      if (!li) return;

      if (!li.classList.contains('bro-gift-line')) {
        li.classList.add('bro-gift-line');

        var titleWrap = li.querySelector('[data-product-title]');
        if (titleWrap && !titleWrap.querySelector('.bro-gift-badge')) {
          var badge = document.createElement('span');
          badge.className = 'bro-gift-badge';
          badge.textContent = GIFT_BADGE_TEXT;
          titleWrap.appendChild(badge);
        }

        var qtyCtrl = li.querySelector('[x-ref="quantityControl"]');
        if (qtyCtrl && !qtyCtrl.querySelector('.bro-gift-fixed-qty')) {
          var fixed = document.createElement('span');
          fixed.className = 'bro-gift-fixed-qty';
          fixed.textContent = 'Qty: 1';
          qtyCtrl.appendChild(fixed);
        }
      }
    });
  }

  // ---------- Observer (narrow, debounced, single) ----------
  function attachObserver() {
    if (observerAttached) return;
    var slot = document.getElementById('right-drawer-slot');
    if (!slot) return;

    var obs = new MutationObserver(function (mutations) {
      // Only react if a top-level child of the cart contents changed
      // (line added/removed, drawer re-rendered). We don't subtree-observe
      // tiny attribute changes — that's what killed performance before.
      if (observerDebounceTimer) clearTimeout(observerDebounceTimer);
      observerDebounceTimer = setTimeout(function () {
        // Cheap UI re-lock (no fetch)
        lockGiftLine();
        // Then check if a real sync is needed (rate-limited internally)
        scheduleSync();
      }, OBSERVER_DEBOUNCE_MS);
    });

    obs.observe(slot, { childList: true, subtree: true });
    observerAttached = true;
  }

  // ---------- Init ----------
  function init() {
    injectStyles();

    // Try to attach observer now; if drawer slot isn't in DOM yet, retry once
    // after a short delay (no infinite interval).
    attachObserver();
    if (!observerAttached) setTimeout(attachObserver, 1000);

    // Initial sync — force because lastSyncAt is 0
    syncGift(true);

    // Event listeners (no self-dispatch loop)
    document.addEventListener('cart:updated', scheduleSync);
    document.addEventListener('cart:refresh', scheduleSync);
    document.addEventListener('theme:cart:change', scheduleSync);
    document.addEventListener('theme:product:add', function () {
      setTimeout(scheduleSync, 300);
    });

    // Sync when the cart UI is opened, but rate-limited
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[href*="/cart"], [data-modal-open="cart"], button[aria-controls*="cart"]')) {
        setTimeout(scheduleSync, 250);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();